export default "__VITE_ASSET__CV4ik8OZ__"